import React from 'react';
import one from '../Assests/SlideNav/1.png';
import two from '../Assests/SlideNav/2.png';
import three from '../Assests/SlideNav/3.png';
import four from '../Assests/SlideNav/4.png';
import five from '../Assests/SlideNav/5.png';
import six from '../Assests/SlideNav/6.png';
import seven from '../Assests/SlideNav/7.png';
import eight from '../Assests/SlideNav/8.png';
import nine from '../Assests/SlideNav/9.png';
import ten from '../Assests/SlideNav/10.png';
import eleven from '../Assests/SlideNav/11.png';
import twelve from '../Assests/SlideNav/12.png';
import thirteen from '../Assests/SlideNav/13.png';
import fourteen from '../Assests/SlideNav/14.png';
import fifteen from '../Assests/SlideNav/15.png';
import sixteen from '../Assests/SlideNav/16.png';
import seventeen from '../Assests/SlideNav/17.png';

const CarouselComponent = () => {
    return (
        <div className="carousel-container">
            <div className="carousel">
                <img className="carousel-image" src={one} alt="Image 1" />
                <img className="carousel-image" src={two} alt="Image 2" />
                <img className="carousel-image" src={three} alt="Image 3" />
                <img className="carousel-image" src={four} alt="Image 4" />
                <img className="carousel-image" src={five} alt="Image 5" />
                <img className="carousel-image" src={six} alt="Image 6" />
                <img className="carousel-image" src={seven} alt="Image 7" />
                <img className="carousel-image" src={eight} alt="Image 8" />
                <img className="carousel-image" src={nine} alt="Image 9" />
                <img className="carousel-image" src={ten} alt="Image 10" />
                <img className="carousel-image" src={eleven} alt="Image 11" />
                <img className="carousel-image" src={twelve} alt="Image 12" />
                <img className="carousel-image" src={thirteen} alt="Image 13" />
                <img className="carousel-image" src={fourteen} alt="Image 14" />
                <img className="carousel-image" src={fifteen} alt="Image 15" />
                <img className="carousel-image" src={sixteen} alt="Image 16" />
                <img className="carousel-image" src={seventeen} alt="Image 17" />

                {/* Duplicating the images for seamless scrolling */}
                <img className="carousel-image" src={one} alt="Image 1" />
                <img className="carousel-image" src={two} alt="Image 2" />
                <img className="carousel-image" src={three} alt="Image 3" />
                <img className="carousel-image" src={four} alt="Image 4" />
                <img className="carousel-image" src={five} alt="Image 5" />
                <img className="carousel-image" src={six} alt="Image 6" />
                <img className="carousel-image" src={seven} alt="Image 7" />
                <img className="carousel-image" src={eight} alt="Image 8" />
                <img className="carousel-image" src={nine} alt="Image 9" />
                <img className="carousel-image" src={ten} alt="Image 10" />
                <img className="carousel-image" src={eleven} alt="Image 11" />
                <img className="carousel-image" src={twelve} alt="Image 12" />
                <img className="carousel-image" src={thirteen} alt="Image 13" />
                <img className="carousel-image" src={fourteen} alt="Image 14" />
                <img className="carousel-image" src={fifteen} alt="Image 15" />
                <img className="carousel-image" src={sixteen} alt="Image 16" />
                <img className="carousel-image" src={seventeen} alt="Image 17" />
            </div>

            <style jsx>{`
                .carousel-container {
                    overflow: hidden; 
                    width: 100%; 
                    height: 80px; 
                    position: relative; 
                    margin-top : 40px;
                    margin-bottom : -100px;
                }

                .carousel {
                    display: flex; 
                    animation: scroll 20s linear infinite; 
                }

                .carousel-image {
                    width: 10%; 
                    height: 65px; 
                    object-fit: cover;
                    margin: 0 15px;
                }

                @keyframes scroll {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(-50%); 
                    }
                }
            `}</style>
        </div>
    );
};

export default CarouselComponent;
